import { put, select, take } from 'redux-saga/effects';
import { updateDraft } from 'modules/Taps/components/NDFL3Light/redux/actions';
import { UPDATE_DRAFT_SUCCESS } from 'modules/Taps/components/NDFL3Light/redux/actionTypes';
import { selectDraft } from 'modules/Taps/components/NDFL3Light/selectors';
import { push } from 'redux-little-router';

/**
 * Overpayments form submit worker
 * @returns {IterableIterator<*>}
 */
export default function* submitOverpaymentsSaga({ payload: { data, step, accountDetails } }) {
  const state = yield select();
  const draft = selectDraft(state);

  yield put(
    updateDraft({
      draft: data
        ? draft
            .set('currentFormId', 'submit')
            .setIn(['payload', 'useReturnClaim', 'use'], data.use)
            .setIn(['payload', 'useReturnClaim', 'return'], data.return)
            .setIn(
              ['payload', 'useReturnClaim', 'accountDetails'],
              accountDetails ? accountDetails : null,
            )
        : draft.set('currentFormId', 'submit').setIn(['payload', 'useReturnClaim'], null),
    }),
  );

  yield take(UPDATE_DRAFT_SUCCESS);
  yield put(push({ query: { step } }, { persistQuery: true }));
}
